import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import { useStyles } from './css';

export interface Breadcrumb {
    link?: string;
    label: string;
}

export const PageHeading: React.FC<{
    title: string | JSX.Element;
    breadcrumbs?: Breadcrumb[];
}> = ({ title, breadcrumbs, children }) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            {breadcrumbs && (
                <Breadcrumbs className={classes.breadcrumbs}>
                    {breadcrumbs.map((b, index) => {
                        if (b.link) {
                            return (
                                <Link
                                    component={RouterLink}
                                    to={b.link}
                                    key={'breadcrumb_' + index}
                                >
                                    {b.label}
                                </Link>
                            );
                        } else {
                            return (
                                <Typography color="textPrimary" key={'breadcrumb_' + index}>
                                    {b.label}
                                </Typography>
                            );
                        }
                    })}
                </Breadcrumbs>
            )}
            <Grid
                container
                justify="space-between"
                alignItems="flex-end"
                className={classes.heading}
            >
                <Grid item>
                    <Typography variant="h5">{title}</Typography>
                </Grid>
                <Grid item>{children}</Grid>
            </Grid>
        </React.Fragment>
    );
};
